// External libraries
import React from 'react';
// @ts-expect-error TODO:@checkout/react-components
import { FullName } from '@checkout/react-components';
import { useStoreState } from '@/store';

// Internal modules
import { getContent } from '@/lib';
import type { HTMLInputHandlers } from '../types';
import { useMountLogging } from '@/lib/reactHooks';

export const Name = (props: HTMLInputHandlers): React.ReactElement => {
  useMountLogging('Name');
  const firstName = useStoreState(({ form }) => form.firstName);
  const lastName = useStoreState(({ form }) => form.lastName);
  const isFormSubmitting = useStoreState(({ ui }) => ui.isFormSubmitting);

  return (
    <FullName
      disabled={isFormSubmitting}
      firstName={firstName}
      labels={{
        firstName: getContent('fieldLabels.firstName'),
        lastName: getContent('fieldLabels.lastName'),
      }}
      lastName={lastName}
      {...props}
    />
  );
};
